import { jsx } from "react/jsx-runtime";
import classNames from "classnames";
import { memo, useRef, useState, useEffect } from "react";
import { forceReflow } from "../../utils/forceReflow.js";
import { toEnumStateClass } from "../../utils/toEnumStateClass.js";
import { useClassNamePrefix } from "../../auxiliary/useClassNamePrefix.js";
import { toEnumViewClass } from "../../utils/toEnumViewClass.js";
import { toStateClass } from "../../utils/toStateClass.js";
const Collapsible = memo((props) => {
  const contentRef = useRef(null);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const [contentHeight, setContentHeight] = useState("auto");
  const [delayedExpanded, setDelayedExpanded] = useState(props.expanded);
  const onTransitionEnd = () => {
    if (!isTransitioning) {
      return;
    }
    setContentHeight("auto");
    setIsTransitioning(false);
    props.onTransitionEnd?.();
    props.expanded ? props.onOpen?.() : props.onClose?.();
  };
  const updateContentHeight = () => {
    const contentHeight2 = `${contentRef.current.getBoundingClientRect().height}px`;
    setContentHeight(contentHeight2);
  };
  useEffect(() => {
    let isMounted = true;
    if (props.expanded !== delayedExpanded) {
      setIsTransitioning(true);
      updateContentHeight();
      requestAnimationFrame(() => {
        if (!isMounted) {
          return;
        }
        forceReflow(contentRef.current);
        setDelayedExpanded(props.expanded);
      });
    }
    return () => {
      isMounted = false;
    };
  }, [delayedExpanded, props.expanded]);
  const prefix = useClassNamePrefix();
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: classNames(
        `${prefix}collapsible`,
        toEnumViewClass(props.transition, "topInsert"),
        toEnumStateClass(delayedExpanded ? "expanded" : "collapsed"),
        toStateClass("transitioning", isTransitioning)
      ),
      style: {
        "--cui-collapsible-content-height": contentHeight
      },
      "aria-hidden": !props.expanded,
      onTransitionEnd,
      children: /* @__PURE__ */ jsx("div", { className: `${prefix}collapsible-content`, ref: contentRef, children: props.children })
    }
  );
});
Collapsible.displayName = "Collapsible";
export {
  Collapsible
};
//# sourceMappingURL=Collapsible.js.map
